import React from 'react';

import ToggleProps from './ToggleProps';
import StyledToggle from './StyledToggle';

const Toggle: React.FC<ToggleProps> = ({ className, label, selected, onToggle, locked }) => {
  return (
    <StyledToggle className={className} locked={locked}>
      {label && <div className="label">{label}</div>}
      <div
        onClick={() => {
          onToggle();
        }}
        className={selected ? 'toggle active' : 'toggle'}
      >
        <div className={`dialog-button ${selected ? '' : 'disabled'}`} />
      </div>
    </StyledToggle>
  );
};

export default Toggle;
